// frontend/src/utils/theme.js
// Eureka AI design tokens — matched exactly to eureka-color-palette.docx

export const COLORS = {
  teal:          '#1DB89A',
  darkTeal:      '#0F6E56',
  midTeal:       '#5DCAA5',
  lightTeal:     '#9FE1CB',
  paleTeal:      '#E1F5EE',
  positive:      '#059669',
  negative:      '#DC2626',
  amber:         '#f59e0b',
  red:           '#ef4444',
  indigo:        '#6366f1',
  purple:        '#8b5cf6',
  pink:          '#ec4899',
  blue:          '#378ADD',
  textPrimary:   '#111827',
  textSecondary: '#6B7280',
  textMuted:     '#9CA3AF',
  border:        '#F3F4F6',
};

// Donut / categorical 10-color palette
export const PALETTE = [
  '#1DB89A', '#0F6E56', '#5DCAA5', '#9FE1CB',
  '#378ADD', '#6366f1', '#f59e0b', '#ef4444',
  '#8b5cf6', '#ec4899',
];

// Intensity colours matching heatmap spec
export const INTENSITY_COLORS = {
  Light:  '#1DB89A',
  Medium: '#f59e0b',
  Heavy:  '#ef4444',
};

export const LOYALTY_COLORS = {
  Solus:   '#1DB89A',
  Dual:    '#f59e0b',
  'Three+': '#6366f1',
};

export const GENDER_COLORS = {
  M: '#1DB89A',
  F: '#6366f1',
  U: '#9CA3AF',
};

// ── ECharts base theme object ─────────────────────────────────────────────
export const echartsTheme = {
  color: PALETTE,
  backgroundColor: 'transparent',
  textStyle: {
    fontFamily: "'Inter', system-ui, sans-serif",
    color: '#6B7280',
  },
  grid: { left: 48, right: 16, top: 12, bottom: 32, containLabel: false },
  tooltip: {
    backgroundColor: '#FFFFFF',
    borderColor: '#E5E7EB',
    borderWidth: 1,
    textStyle: { color: '#111827', fontSize: 12, fontFamily: "'Inter', system-ui" },
    extraCssText: 'box-shadow: 0 4px 12px rgba(0,0,0,0.08); border-radius: 8px;',
  },
  legend: {
    textStyle: { fontSize: 11, fontFamily: "'Inter', system-ui", color: '#6B7280' },
    itemWidth: 10,
    itemHeight: 10,
  },
  xAxis: {
    axisLine:  { show: false },
    axisTick:  { show: false },
    axisLabel: { fontSize: 11, color: '#9CA3AF' },
    splitLine: { show: false },
  },
  yAxis: {
    axisLine:  { show: false },
    axisTick:  { show: false },
    axisLabel: { fontSize: 11, color: '#9CA3AF' },
    splitLine: { lineStyle: { color: '#F3F4F6', type: 'dashed' } },
  },
};

// ── Dark mode overrides ───────────────────────────────────────────────────
export const echartsThemeDark = {
  ...echartsTheme,
  tooltip: {
    ...echartsTheme.tooltip,
    backgroundColor: '#1e293b',
    borderColor: '#334155',
    textStyle: { ...echartsTheme.tooltip.textStyle, color: '#f1f5f9' },
  },
  legend: { ...echartsTheme.legend, textStyle: { ...echartsTheme.legend.textStyle, color: '#94a3b8' } },
  xAxis: { ...echartsTheme.xAxis, axisLabel: { fontSize: 11, color: '#64748b' } },
  yAxis: {
    ...echartsTheme.yAxis,
    axisLabel: { fontSize: 11, color: '#64748b' },
    splitLine: { lineStyle: { color: '#334155', type: 'dashed' } },
  },
};

// ── Formatters ────────────────────────────────────────────────────────────
export function fmtNum(n) {
  if (n == null) return '—';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (n >= 1_000)     return (n / 1_000).toFixed(1) + 'K';
  return n.toLocaleString();
}

export function fmtPct(n) {
  if (n == null) return '—';
  return n.toFixed(1) + '%';
}

// '2025-11-01' → 'Nov 25' — short month label for chart axes
export function fmtMonth(m) {
  if (!m) return '';
  const d = new Date(m);
  return isNaN(d) ? m : d.toLocaleDateString('en-GB', { month: 'short', year: '2-digit' });
}

export const AGE_ORDER = ['18-24', '25-34', '35-44', '45-54', '55-64', 'Over 65', 'Unknown'];
export const SESSION_LABELS = {
  open_app:                   'Open App',
  transactional_activity:     'Transactional',
  commerce_intent:            'Commerce Intent',
  user_engagement:            'Engagement',
  login:                      'Login',
  driver_activity:            'Driver Activity',
  'merchant-partner_activity':'Merchant/Partner',
  all_sessions:               'All Sessions',
};
